export { default } from './Social';
